export { default } from './Social';
